import JivoUtils from '~/mixins/jivo-utils'

export default {
  mixins: [JivoUtils],
  beforeMount() {
    /**
     * Находит все items в localStorage, которые содержат идентификаторы jivoSite (jv_)
     */
    const getJivoSiteLocalStorage = function() {
      let keys = []

      if (window.localStorage) {
        keys = Object.keys(window.localStorage)

        keys.filter(key => {
          const regexp = /jv_store_(.*?)_client/g

          if (key.match(regexp)) {
            const jivoSiteItem = JSON.parse(window.localStorage.getItem(key))
            const jivoSiteId = jivoSiteItem.client_id
              ? jivoSiteItem.client_id.split('.')
              : []
            window.jivoClientId = jivoSiteId[0]
          }
        })
      }
    }

    const setJivoCookie = function() {
      const domain = window.location.hostname === 'localhost'
        ? `localhost`
        : `.${window.location.hostname}`
      if (window.jivoClientId) {
        document.cookie = `jivoClientId=${window.jivoClientId}; domain=${domain};`
      }
    }

    window.jivo_onLoadCallback = function() {
      window.isJivoInit = true
      window.isJivoMobile = /iPhone|iPad|iPod|Android|Windows Phone/i.test(navigator.userAgent.toLowerCase())
      window.JivoState = 'label'
    }

    window.jivo_onOpen = function() {
      window.isJivoWasOpen = true
      window.isJivoOpen = true
    }

    window.jivo_onClose = function() {
      window.isJivoWasOpen = true
      window.isJivoOpen = false
    }

    window.jivo_onMessageSent = function() {
      setTimeout(() => {
        getJivoSiteLocalStorage()
        setJivoCookie()
        if (document.readyState === 'complete' && window.jivoClientId) {
          window.jivo_api.setUserToken(window.jivoClientId.toString())
        }
      }, 500)
    }
  }
}